import { type FieldError } from 'react-hook-form'
import { useCallback } from 'react'
import {
  type FormValidationType,
  type FormErrorMessageMap,
} from 'utils/react-hook-form/reactHookForm.types'

export const useFormErrorMessageMap = (mapping: FormErrorMessageMap) =>
  useCallback(
    (fieldError?: FieldError) => {
      if (!fieldError) return undefined

      const errorType = fieldError.type as FormValidationType

      return mapping[errorType]
    },
    [mapping]
  )
